import { Wrapper } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.td`
  ${({ displayState }) => css`
    background-color: ${displayState?.selected ? '#C7EFDA' : ''};
    border: ${displayState?.selected || displayState?.input ? `solid 1px ${window?.settings?.primary_color ?? '#1DBD6B'} !important` : ''};
  `}
`;

export default Wrapper(template);